<div class="login-container">
  <!-- Background with gradient overlay -->
  <div class="login-background">
    <div class="background-overlay"></div>
  </div>

  <!-- Main login card -->
  <div class="login-card">
    <!-- Header section -->
    <div class="login-header">
      <div class="logo-container">
        <!-- Placeholder for company logo -->
        <div class="logo-placeholder">
          <img src="assets/portal/images/stem/logo-white.png" alt="STEM Logo" class="stem-logo" />
        </div>
      </div>
      <h1 class="login-title">Welcome Back</h1>
      <p class="login-subtitle">Sign in to your account to continue</p>
    </div>

    <!-- Login form -->
    <div class="login-form-container">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <!-- Username field -->
        <div class="form-field">
          <label for="username" class="field-label">
            <i class="pi pi-user field-icon"></i>
            Username
          </label>
          <div class="input-container">
            <input
              id="username"
              type="text"
              formControlName="username"
              class="form-input"
              [class.input-error]="isFieldInvalid('username')"
              placeholder="Enter your username"
              autocomplete="username"
              [attr.aria-describedby]="isFieldInvalid('username') ? 'username-error' : null"
              [attr.aria-invalid]="isFieldInvalid('username')"
            />
            <i class="pi pi-user input-icon"></i>
          </div>
          <div
            *ngIf="isFieldInvalid('username')"
            class="error-message"
            id="username-error"
            role="alert"
          >
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ getFieldError('username') }}</span>
          </div>
        </div>

        <!-- Password field -->
        <div class="form-field">
          <label for="password" class="field-label">
            <i class="pi pi-lock field-icon"></i>
            Password
          </label>
          <div class="input-container">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              class="form-input"
              [class.input-error]="isFieldInvalid('password')"
              placeholder="Enter your password"
              autocomplete="current-password"
              [attr.aria-describedby]="isFieldInvalid('password') ? 'password-error' : null"
              [attr.aria-invalid]="isFieldInvalid('password')"
            />
            <i class="pi pi-lock input-icon"></i>
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
            </button>
          </div>
          <div
            *ngIf="isFieldInvalid('password')"
            class="error-message"
            id="password-error"
            role="alert"
          >
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ getFieldError('password') }}</span>
          </div>
        </div>

        <!-- Remember me and forgot password -->
        <div class="form-options">
          <div class="remember-me">
            <p-checkbox
              id="rememberMe"
              [binary]="true"
              [(ngModel)]="rememberMe"
              [ngModelOptions]="{ standalone: true }"
              styleClass="custom-checkbox"
            ></p-checkbox>
            <label for="rememberMe" class="checkbox-label">Remember me</label>
          </div>
          <div class="forgot-links">
            <a class="forgot-password-link" [routerLink]="['/forgot-password']" tabindex="0">
              Forgot password?
            </a>
            <a class="forgot-password-link" [routerLink]="['/forgot-username']" tabindex="0">
              Forgot username?
            </a>
          </div>
        </div>

        <!-- Submit button -->
        <button
          type="submit"
          class="login-button"
          [disabled]="loading || loginForm.invalid"
          [class.loading]="loading"
        >
          <span *ngIf="!loading" class="button-content">
            <i class="pi pi-sign-in"></i>
            Sign In
          </span>
          <span *ngIf="loading" class="button-content">
            <i class="pi pi-spin pi-spinner"></i>
            Signing In...
          </span>
        </button>

        <!-- Error message -->
        <div *ngIf="error" class="error-alert" role="alert" aria-live="polite">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ error }}</span>
        </div>
      </form>

      <!-- Divider -->
      <div class="divider">
        <span class="divider-text">or continue with</span>
      </div>

      <!-- Social login options -->
      <div class="social-login">
        <button
          type="button"
          class="social-button google-button"
          disabled
          aria-label="Sign in with Google (coming soon)"
        >
          <i class="pi pi-google"></i>
          <span>Google</span>
        </button>
        <button
          type="button"
          class="social-button microsoft-button"
          disabled
          aria-label="Sign in with Microsoft (coming soon)"
        >
          <i class="pi pi-microsoft"></i>
          <span>Microsoft</span>
        </button>
      </div>

      <!-- Footer -->
      <div class="login-footer">
        <p class="footer-text">
          Don't have an account?
          <a href="#" class="signup-link" (click)="onSignupClick($event)">
            Contact your administrator
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
